import * as turf from "@turf/turf";
import L, { LatLng } from "leaflet";

export const enforceMinRectangleSize = (positions: LatLng[], minSize = 1): LatLng[] => {
  if (!positions || positions.length !== 4) return positions;

  let [p1, p2, p3, p4] = positions;

  const width = p1.distanceTo(p2);
  const height = p2.distanceTo(p3);

  if (width < minSize) {
    const from = turf.point([p1.lng, p1.lat]);
    const bearing = turf.bearing(from, turf.point([p2.lng, p2.lat]));
    const newP2Coords = turf.destination(from, minSize, bearing, { units: "meters" }).geometry
      .coordinates;
    const newP2 = new L.LatLng(newP2Coords[1], newP2Coords[0]);

    const fromP4 = turf.point([p4.lng, p4.lat]);
    const newP3Coords = turf.destination(fromP4, minSize, bearing, { units: "meters" }).geometry
      .coordinates;
    const newP3 = new L.LatLng(newP3Coords[1], newP3Coords[0]);

    p2 = newP2;
    p3 = newP3;
  }

  if (height < minSize) {
    const from = turf.point([p2.lng, p2.lat]);
    const bearing = turf.bearing(from, turf.point([p3.lng, p3.lat]));
    const newP3Coords = turf.destination(from, minSize, bearing, { units: "meters" }).geometry
      .coordinates;
    const newP3 = new L.LatLng(newP3Coords[1], newP3Coords[0]);

    const fromP1 = turf.point([p1.lng, p1.lat]);
    const newP4Coords = turf.destination(fromP1, minSize, bearing, { units: "meters" }).geometry
      .coordinates;
    const newP4 = new L.LatLng(newP4Coords[1], newP4Coords[0]);

    p3 = newP3;
    p4 = newP4;
  }

  return [p1, p2, p3, p4];
};
